export default __webpack_public_path__ + "static/media/made-easy-phone-center.54883f6c.webp";